import React from "react";
import { P_Props } from "./QuotationDetail.type";
// import { loadCallback } from "../../../../utils";
import { Loading, SimpleModalHeader } from "../../../components";
import { Grid, Divider } from "@material-ui/core";
import moment from "moment";

const QuotationDetailPresenter: React.FC<P_Props> = (props) => {
  return (
    <>
      <div className="quotation-detail">
        <SimpleModalHeader
          title="Quotation Detail"
          onClose={() => {
            props.onClose();
          }}
        />
        <div className="quotation-detail__container">
          {props.loading && <Loading />}
          {!props.loading && (
            <>
              <div className="quotation-detail__info">
                <Grid container>
                  <Grid item xs={12}>
                    <h2 className="quotation-detail__section">
                      {props.detailData?.freight_forwarding
                        ? "freight forwarding service"
                        : props.detailData?.ecommerce
                          ? "e-commerce fulfillment service"
                          : "service"
                      }
                    </h2>
                  </Grid>
                  {props.detailData?.freight_forwarding && (
                    <Grid item xs={12} lg={6}>
                      <h4 className="quotation-detail__title">Mode of transport</h4>
                      <div className="quotation-detail-text">
                        {props.detailData?.freight_forwarding.modeOfTransport}
                      </div>
                    </Grid>
                  )}
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">Request Date</h4>
                    <div className="quotation-detail-text">
                      {`${moment(props.detailData?.createdAt).format("DD/MM/yyyy")} at ${moment(props.detailData?.createdAt).format("hh:mm")} `}
                    </div>
                  </Grid>
                  {props.detailData?.ecommerce && (
                    <Grid item xs={12} lg={6}></Grid>
                  )}
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">Customer</h4>
                    <div className="quotation-detail-text">{props.detailData?.fullName}</div>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">E-mail</h4>
                    <div className="quotation-detail-text">{props.detailData?.email}</div>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">Contact number</h4>
                    <div className="quotation-detail-text">{props.detailData?.phone}</div>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">Company URL</h4>
                    <div className="quotation-detail-text">{props.detailData?.companyURL}</div>
                  </Grid>
                  <Grid item xs={12} lg={6}>
                    <h4 className="quotation-detail__title">Address</h4>
                    <div className="quotation-detail-text">{props.detailData?.address}</div>
                  </Grid>
                  <Divider style={{ width: "100%", margin: "3rem 0" }} />

                  <Grid item xs={12}>
                    <h2 className="quotation-detail__section">SHIPPING DETAIL</h2>
                  </Grid>
                  {/* FREIGHT FORWARD SERVICE */}
                  {props.detailData?.freight_forwarding && (
                    <>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Port of loading</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.portOfLoading}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Port of discharge</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.portOfDischarge}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Mode of service</h4>
                        <div className="quotation-detail-text">
                          {props.detailData.freight_forwarding.modeOfService === "lcl"
                            ? "LCL"
                            : props.detailData.freight_forwarding.modeOfService === "fcl"
                              ? "FCL"
                              : props.detailData.freight_forwarding.modeOfService === "ltl"
                                ? "LTL"
                                : props.detailData.freight_forwarding.modeOfService === "ftl"
                                  ? "FTL"
                                  : props.detailData.freight_forwarding.modeOfService === "parcel"
                                    ? "Parcel" : ""
                          }
                        </div>
                      </Grid>
                      <Divider style={{ width: "100%", margin: "3rem 0" }} />
                      <Grid item xs={12}>
                        <h2 className="quotation-detail__section">Warehouse</h2>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Commodity</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.commodity}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}></Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Number of SKU</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.numberOfSKU}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Storage</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.storage}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <h4 className="quotation-detail__title">Note</h4>
                        <div className="quotation-detail-text">{props.detailData.freight_forwarding.note}</div>
                      </Grid>
                    </>
                  )}

                  {/* E-COMMERCE FULFILLMENT SERVICE */}
                  {props.detailData?.ecommerce && (
                    <>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Order per month</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.orderPerMonth}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Items per order</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.itemsPerOrder}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Number of SKU</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.numberOfSKU}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Weight of Parcel</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.weightOfParcel}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Webshop platform</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.webshopPlatform}</div>
                      </Grid>
                      <Grid item xs={12} lg={6}>
                        <h4 className="quotation-detail__title">Storage</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.storage}</div>
                      </Grid>
                      <Grid item xs={12}>
                        <h4 className="quotation-detail__title">Note</h4>
                        <div className="quotation-detail-text">{props.detailData.ecommerce.note}</div>
                      </Grid>
                    </>
                  )}
                </Grid>
              </div>

              <div className="quotation-detail__history">
                <h2 className="quotation-detail__section">Quotation History</h2>
                <Divider style={{ width: "100%", margin: "1.5rem 0" }} />
                <div className="quotation-detail__request-info">
                  {props.quotationDetail.map((content) => {
                    return (
                      <div key={content.id} className="quotation-detail__request-content">{content.action}</div>
                    )
                  })}
                </div>
              </div>
            </>
          )}
        </div>

        <div className="quotation-detail__footer">
          <button
            className="btn close"
            onClick={(e) => {
              e.preventDefault();
              props.onClose();
            }}
          >
            Close
          </button>
        </div>
      </div>
    </>
  );
};

export default QuotationDetailPresenter;